import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PrivacyPolicy() {
    return (
        <div className="bg-white min-h-screen" data-testid="privacy-policy-page">
            <Navbar onBookingClick={() => {}} />
            <div className="pt-24 pb-16 md:pt-32 md:pb-24">
                <div className="max-w-3xl mx-auto px-6 md:px-12">
                    <h1 className="text-4xl sm:text-5xl font-light tracking-tighter mb-8">Integritetspolicy</h1>
                    <p className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-12">Senast uppdaterad: April 2026</p>

                    <div className="space-y-8 text-sm text-neutral-600 leading-relaxed">
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">1. Personuppgiftsansvarig</h2>
                            <p>Biro Stockholm AB, org.nr 559432-6141, Manhemsvägen 7, 13146 Nacka, är personuppgiftsansvarig för behandlingen av dina personuppgifter.</p>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">2. Vilka uppgifter vi samlar in</h2>
                            <p>Vi samlar in följande personuppgifter:</p>
                            <ul className="list-disc pl-5 mt-2 space-y-1">
                                <li>Namn, e-postadress och telefonnummer vid bokning eller kontakt</li>
                                <li>Körkortsinformation vid bokning av provkörning</li>
                                <li>Betalningsinformation (hanteras av Stripe)</li>
                                <li>Teknisk information som IP-adress och webbläsartyp</li>
                            </ul>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">3. Ändamål med behandlingen</h2>
                            <p>Vi behandlar dina personuppgifter för att:</p>
                            <ul className="list-disc pl-5 mt-2 space-y-1">
                                <li>Hantera bokningar och provkörningar</li>
                                <li>Kommunicera med dig angående din bokning</li>
                                <li>Skicka bokningsbekräftelser och påminnelser</li>
                                <li>Förbättra vår tjänst och webbplats</li>
                            </ul>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">4. Laglig grund</h2>
                            <p>Behandlingen baseras på avtal (genomförande av bokning), samtycke (marknadsföring) och berättigat intresse (förbättring av tjänster).</p>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">5. Delning av uppgifter</h2>
                            <p>Vi delar dina uppgifter med Stripe (betalningshantering) och Resend (e-postleverans). Vi säljer aldrig dina personuppgifter till tredje part.</p>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">6. Lagring</h2>
                            <p>Personuppgifter lagras så länge det är nödvändigt för att uppfylla ändamålet med behandlingen, dock högst 24 månader efter senaste kontakt.</p>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">7. Dina rättigheter</h2>
                            <p>Du har rätt att begära tillgång till, rättelse av, radering av eller begränsning av behandlingen av dina personuppgifter. Du har också rätt att invända mot behandling och rätt till dataportabilitet. Kontakta oss på info@biro.se.</p>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">8. Cookies</h2>
                            <p>Vi använder nödvändiga cookies för att webbplatsen ska fungera korrekt samt analytiska cookies för att förbättra vår tjänst. Du kan hantera cookies i din webbläsares inställningar.</p>
                        </section>
                        <section>
                            <h2 className="text-lg font-medium text-black mb-3">9. Kontakt</h2>
                            <p>Vid frågor om vår hantering av personuppgifter, kontakta oss:</p>
                            <p className="mt-2">Biro Stockholm AB<br />Manhemsvägen 7, 13146 Nacka<br />info@biro.se</p>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
